import type { DisplaySeat } from '~/features/reservationInput/store/stateMachine/statemachine'
import { money } from '~/lib/money/money'
import { sva } from '~/styled-system/css'

const styles = sva({
  slots: ['container', 'restriction', 'text'],
  base: {
    container: {
      spaceY: '1',
      color: 'gray.700',
      _pc: {
        fontSize: 'md',
      },
    },
    restriction: {
      fontSize: 'sm',
      fontWeight: 'bold',
    },
    text: {
      fontSize: 'sm',
      lineHeight: 'snug',
    },
  },
})

export function Description({ seat }: { seat: DisplaySeat }) {
  const classes = styles()
  return (
    <div className={classes.container}>
      {seat.childrenRestriction !== undefined && (
        <p className={classes.restriction}>{seat.childrenRestriction}</p>
      )}
      {seat.charge.__typename !== 'SeatChargeNoCharge' && (
        <p className={classes.text}>
          チャージ料 {money(seat.chargeAmount)}円 {seat.chargeDetails}
        </p>
      )}
      {seat.seatTypeDescription !== null && (
        <p className={classes.text}>{seat.seatTypeDescription}</p>
      )}
    </div>
  )
}
